import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/poojaagrawal/Projects/itellisecure/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/poojaagrawal/Projects/itellisecure/src/components/Navbar.tsx");
